/**
 * @description 加油包助力明细
 * @author Kody
 * @date 2019-08-05
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

import IInput from './models/input';
import { IOutput } from './models/output';

export const getBoostList = (data: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.GET_BOOST_LIST, data).then((res: IListResponse<IOutput>) => {
        return res;
    });
};
